import Loader from "react-spinners/ClipLoader";
import "./Button.scss";

const Button = ({
  buttonType,
  text,
  isLoading,
  prefixIcon,
  suffixIcon,
  icon,
  buttonRef,
  disabled,
  className,
  ...restProps // ✅ only safe props (onClick, type, id, etc.) go here
}) => {
  const renderButton = () => {
    switch (buttonType) {
      case "primary":
        return (
          <button
            className={`btn emr-btn__primary ${className}`}
            ref={buttonRef}
            disabled={disabled}
            {...restProps}
          >
            {prefixIcon}
            {isLoading ? <Loader color="#fff" size={14} /> : text}
            {suffixIcon}
          </button>
        );

      case "secondary":
        return (
          <button className="btn emr-btn__secondary" {...restProps}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      case "light":
        return (
          <button className="btn emr-btn__light" {...restProps}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      case "icon":
        return (
          <button className="btn emr-btn__light" {...restProps}>
            {icon}
          </button>
        );

      case "danger":
        return (
          <button className="btn emr-btn__danger" {...restProps}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      case "outline":
        return (
          <button className="btn emr-btn__outline" {...restProps}>
            {prefixIcon}
            {isLoading ? <Loader color="var(--primary)" size={14} /> : text}
            {suffixIcon}
          </button>
        );

      case "button":
        return (
          <button className="btn emr-btn__apply" {...restProps}>
            {text} {icon}
          </button>
        );

      case "dropdown":
        return (
          <button className="btn emr-btn__dropdown" {...restProps}>
            {text} {icon}
          </button>
        );

      case "text":
        return (
          <button className="btn emr-btn__text" {...restProps}>
            {text}
          </button>
        );

      case "amountBtn":
        return (
          <button className="quickAmt no-border btn btn-xs btn-outline-secondary" {...restProps}>
            {text}
          </button>
        );

      case "link":
        return (
          <button className="btn emr-btn__link" {...restProps}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      default:
        return (
          <button className="primary btn icon" ref={buttonRef} {...restProps}>
            {text} {icon}
          </button>
        );
    }
  };

  return renderButton();
};

export default Button;
